"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLinkedDataObject = void 0;
var jsonld_dataset_proxy_1 = __importDefault(require("jsonld-dataset-proxy"));
var o_dataset_pack_1 = require("o-dataset-pack");
var datasetConverters_1 = require("./datasetConverters");
function createLinkedDataObject(dataset, entryNode, shapeType) {
    var proxy = (0, jsonld_dataset_proxy_1.default)(dataset, shapeType.context, entryNode);
    var ldoMethods = getLdoMethods(dataset, entryNode, shapeType);
    return new Proxy(proxy, {
        get: function (target, key) {
            // @ts-expect-error key casting required for methods
            if (ldoMethods[key]) {
                // @ts-expect-error key casting required for methods
                return ldoMethods[key];
            }
            // @ts-expect-error key casting required for methods
            return target[key];
        },
    });
}
exports.createLinkedDataObject = createLinkedDataObject;
function getLdoMethods(dataset, entryNode, shapeType) {
    return {
        /**
         * Clone
         */
        $clone: function () {
            var subscribableDataset = (0, o_dataset_pack_1.createSubscribableDataset)();
            subscribableDataset.addAll(dataset);
            return createLinkedDataObject(subscribableDataset.startTransaction(), entryNode, shapeType);
        },
        /**
         * Changes
         */
        $changes: function () {
            return dataset.getChanges();
        },
        /**
         * Dataset
         */
        $dataset: function () {
            return dataset;
        },
        /**
         * isValid
         */
        $isValid: function () {
            throw new Error("Not Implemented");
            // // Transfer Quads into an N3 Datastore
            // const g = new Store();
            // dataset.forEach((quad) => {
            //   g.addQuad(quad);
            // });
            // // Validate
            // const validationResult = ShexValidator.construct(
            //   shapeType.schema,
            //   ctor(g),
            //   {}
            // ).validate([
            //   {
            //     node: entryNode.value,
            //     shape: shapeType.shape,
            //   },
            // ]);
            // return !validationResult.errors;
        },
        /**
         * toSparqlUpdate
         */
        $toSparqlUpdate: function () {
            return __awaiter(this, void 0, void 0, function () {
                var changes, output, _a, _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            changes = dataset.getChanges();
                            output = "";
                            if (!changes.added) return [3 /*break*/, 2];
                            _a = output;
                            _b = "INSERT DATA { ".concat;
                            return [4 /*yield*/, (0, datasetConverters_1.datasetToString)(changes.added, {
                                    format: "N-Triples",
                                })];
                        case 1:
                            output = _a + _b.apply("INSERT DATA { ", [_e.sent(), " }"]);
                            _e.label = 2;
                        case 2:
                            if (changes.added && changes.removed) {
                                output += "; ";
                            }
                            if (!changes.removed) return [3 /*break*/, 4];
                            _c = output;
                            _d = "DELETE DATA { ".concat;
                            return [4 /*yield*/, (0, datasetConverters_1.datasetToString)(changes.removed, {
                                    format: "N-Triples",
                                })];
                        case 3:
                            output = _c + _d.apply("DELETE DATA { ", [_e.sent(), " }"]);
                            _e.label = 4;
                        case 4: return [2 /*return*/, output.replaceAll("\n", " ")];
                    }
                });
            });
        },
        /**
         * Serialize
         */
        $serialize: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, (0, datasetConverters_1.datasetToString)(dataset, options)];
                });
            });
        },
        /**
         * toTurtle
         */
        $toTurtle: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, (0, datasetConverters_1.datasetToString)(dataset, {})];
                });
            });
        },
        /**
         * toJsonLd
         */
        $toJsonLd: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, (0, datasetConverters_1.datasetToJsonLd)(dataset, shapeType.context)];
                });
            });
        },
        /**
         * toNTriples
         */
        $toNTriples: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, (0, datasetConverters_1.datasetToString)(dataset, { format: "N-Triples" })];
                });
            });
        },
    };
}
